/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Select_Files_Left_To_BeginInputs */



/**
* | output |
* | --- |
* | "Select files using the input on the left to begin" |
*
* @param {Select_Files_Left_To_BeginInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const select_files_left_to_begin = /** @type {((inputs?: Select_Files_Left_To_BeginInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Select_Files_Left_To_BeginInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionnez des fichiers à gauche pour commencer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie zum Starten Dateien über die Eingabefelder auf der linken Seite aus.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Selezionare i file utilizzando l'input a sinistra per iniziare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Для начала выберите файлы, используя поле ввода слева.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione archivos utilizando la entrada de la izquierda para comenzar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("使用左侧的输入框选择文件开始")
	if (locale === "ja") return /** @type {LocalizedString} */ ("左の入力を使用してファイルを選択して開始します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शुरू करने के लिए बाईं ओर दिए गए इनपुट का उपयोग करके फ़ाइलें चुनें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione os arquivos usando a entrada à esquerda para começar.")
	return /** @type {LocalizedString} */ ("Select files using the input on the left to begin")
});